<template>
  <div class="rows is-full-height is-gapless"
  :class="{
    no_display_id: headers[0] &&
    !headers[0].display
  }">
    <v-modal 
    v-model="modal_action_open"
    class="is-half">
      <div class="rows is-full-height is-gapless">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Modification de masse</span>
          </nav>
        </div>
        <div class="row is-narrow"
          style="padding: 10px; height: 30px;">
          <div style="width: 100%; padding: 0 10px; ">
            Appliquer à: &nbsp;
            <label
            :disabled="selected.length === 0">
                <v-radio
                :disable="selected.length === 0"
                val="sel"
                v-model="action_mode"
                ></v-radio>
                La sélection &nbsp;
              </span>
            </label> 
            <label>
                <v-radio
                val="search"
                v-model="action_mode"></v-radio>
                Recherche complète &nbsp;
              </span>
            </label>
          </div>
        </div>
        <div class="row is-full-height"
        style="padding: 10px; overflow: auto;">
          <div class="rows is-full-height0 is-gapless0">
            <div v-for="(action, index) in actions"
            class="row is-narrow"
            style="padding: 0;">
              <div class="columns is-gapless0 full-width">
                <div class="column is-2">
                  <v-select
                  class="floating-label full-width"
                  placeholder="Action"
                  :opened.sync="action.action_opened"
                  :hasReset="false"
                  v-model="action.data.action"
                  :items="action_items"
                  @input="onActionSelect($event, index)">
                  </v-select>
                </div>
                <div class="column is-2">
                  <v-select
                  class="floating-label full-width"
                  :opened.sync="action.subject_opened"
                  placeholder="Objet"
                  :hasReset="false"
                  v-model="action.data.data_type_id"
                  :items="(type_str === 'contact' || type_str === 'contact_externe' )? action_type_items : action_type_items_group_only"
                  @input="onActionObjectSelect($event, index)">
                  </v-select>
                </div>

                <div class="column is-2">
                  <v-select 
                  class="floating-label full-width"
                  placeholder="Type"
                  :opened.sync="action.type_opened"
                  :items="(action.data.data_type_id == 7)? group_attr : organization_attr"
                  v-model="action.type_id"
                  @input="onActionTypeSelect($event, index)">
                  </v-select>
                </div>
                <div class="column">
                  <v-form-dropdown search fluid
                  :placeholder="(action.data.data_type_id == 7)? 'Groupe' : 'Organisation'"
                  :opened.sync="action.opened"
                  class="input-control no-overflow full-width"
                  v-model="action.data.value"
                  :filter="action.input"
                  :display="action.display"
                  :items="action.items"
                  :min_letters="0"
                  @click.stop.prevent
                  @filter="onActionFilter($event, index)"
                  @input="function (item_id, item) {
                    onActionDataSelect(item_id, item, index)
                  }">
                  </v-form-dropdown>
                </div>
                <div class="column is-2"
                v-if="action.data.data_type_id == 8">
                  <v-select
                  class="floating-label full-width"
                  placeholder="Rôle"
                  v-model="action.data.rel_type_id"
                  :items="get_attributes(action.type_id)">
                  </v-select>
                </div>
                <div class="column is-1 item-icon">
                  <span class="flex is-full-height justify-end items-end">
                    <div class="button"
                    v-if="index > 0"
                    @click="onActionDel(index)">
                      <i class="del"></i>
                    </div>
                    <div class="button"
                    v-else
                    @click="onActionAdd">
                      <i class="plus"></i>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row is-narrow">
          <nav class="navbar primary">
              <div
              :disabled="action_mode === ''"
              class="button primary full-width"
              style="border: 0;"
              @click="submitAction">Appliquer</div>
            </nav>
          </nav>
        </div>
      </div>
    </v-modal>

    <v-modal 
    v-model="modal_export_open"
    class="is-half"
    style="max-height0: 25%">
      <div class="rows is-full-height is-gapless">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Exporter</span>
          </nav>
        </div>
        <div class="row is-full-height"
        style="padding: 10px; overflow: auto;">
          <div style="width: 100%;">
            <div class="row">
              <div style="width: 100%;">
                <label
                :disabled="selected.length === 0">
                    <v-radio
                    :disable="selected.length === 0"
                    val="sel"
                    v-model="export_mode"></v-radio>
                    La sélection &nbsp;
                  </span>
                </label> 
                <label>
                    <v-radio
                    val="search"
                    v-model="export_mode"></v-radio>
                    Recherche complète &nbsp;
                  </span>
                </label> 
              </div>
            </div>
          </div>
        </div>
        <div class="row is-narrow">
          <nav class="navbar primary">
              <div
              :disabled="export_mode === ''"
              class="button primary full-width"
              style="border: 0;"
              @click="submitExport">Envoyer</div>
            </nav>
          </nav>
        </div>
      </div>
    </v-modal>

    <v-modal 
    v-model="modal_univers_open"
    class="is-half">
      <div class="rows is-full-height is-gapless">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Carnet</span>
          </nav>
        </div>
        <div class="row is-full-height"
        style="padding: 10px; overflow: auto;">
          <div style="width: 100%;">

            <div class="row">
              <div style="width: 100%;">
                <div style="padding-bottom: 10px;">
                  <b>Action:</b> &nbsp;
                </div>
                <label
                  :disabled="!seeAll && !is_report">
                    <v-radio
                    :disable="!seeAll && !is_report"
                    val="add"
                    v-model="univers_action"></v-radio>
                    Ajouter au carnet &nbsp;
                  </span>
                </label> 
                <label :disable="!is_report">
                    <v-radio
                    :disable="!is_report"
                    val="del"
                    v-model="univers_action"></v-radio>
                    Supprimer du carnet &nbsp;
                  </span>
                </label>
              </div>
            </div>

            <div class="row">
              <div style="width: 100%;">
                <div style="padding-bottom: 10px;">
                  <b>Appliquer à:</b> &nbsp;
                </div>
                <label
                :disabled="selected.length === 0">
                    <v-radio
                    :disable="selected.length === 0"
                    val="sel"
                    v-model="univers_mode"></v-radio>
                    La sélection &nbsp;
                  </span>
                </label> 
                <label>
                    <v-radio
                    val="search"
                    v-model="univers_mode"></v-radio>
                    Recherche complète &nbsp;
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row is-narrow">
          <nav class="navbar primary">
            <div
            :disabled="univers_mode === '' || univers_action === ''"
            class="button primary full-width"
            style="border: 0;"
            @click="submitUnivers">
              Envoyer
            </div>
          </nav>
        </div>
      </div>
    </v-modal>

    <v-modal 
    v-model="modal_univers_single_open"
    class="is-half">
      <div class="rows is-full-height is-gapless">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Carnet</span>
          </nav>
        </div>
        <div class="row is-full-height"
        style="padding: 10px; overflow: auto;">
          <div style="width: 100%;">

            <div class="row">
              <div
              v-if="modal_univers_single_action.action === 'add'"
              style="width: 100%;">
                Ajouter au carnet ?
              </div>
              <div
              v-else
              style="width: 100%;">
                Retirer du carnet ?
              </div>
            </div>

          </div>
        </div>
        <div class="row is-narrow">
          <nav class="navbar primary">
              <div
              class="button primary full-width"
              style="border: 0;"
              @click="universModalSubmit">OK</div>
          </nav>
        </div>
      </div>
    </v-modal>

    <v-modal 
    v-model="modal_merge_open"
    class="is-half">
      <div class="rows is-full-height is-gapless">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Merge</span>
          </nav>
        </div>
        <div class="row is-full-height"
        style="padding: 10px; overflow: auto;">
          <div style="width: 100%;">
            <!-- items -->
            <label v-for="item in merge_items"
            class='radio-item-list'>
              <v-radio
              :val="item.data[0]"
              v-model="merge_main_id"></v-radio>
              <span v-text="item.data[2]"></span>&nbsp;
              <span v-text="item.data[3]"></span>
            </label>
          </div>
        </div>
        <div class="row is-narrow">
          <nav class="navbar primary">

            <div
            class="button primary full-width"
            style="border: 0;"
            @click="merge_contacts">
              Valider
            </div>
          </nav>
        </div>
      </div>
    </v-modal>

    <div class="row is-narrow">
      <nav class="navbar primary">
        <div class="navbar-nav search-nav"
        style="padding-bottom: 0; padding-right: 0;">
          <div class="columns is-gapless">
            <div class="column">
              <div class="columns is-gapless is-multiline">
                <div v-for="(search, index) in searchs"
                class="column is-5"
                :class="{
                  'is-10': (search.data.field === 'organization' ||
                        search.data.field === 'cat')
                }"
                style="padding-bottom: 0.5rem; padding-right: 0.5rem;">
                  <div class="search-block">
                    <div class="field has-addons">
                      <div class="control">
                        <v-dropdown
                        :opened.sync="search.field_opened">
                          <template slot="display">
                            <div class="button">
                              <i
                              :class="(search_fields_index[search.data.field]) ? search_fields_index[search.data.field].icon : ''"></i>
                              <i class="caret-down"></i>
                            </div>
                          </template>
                          <template slot="content">
                            <div
                            v-for="search_field in search_fields"
                            :key="search_field.id"
                            class="item"
                            :class="{
                              'selected': search.data.field === search_field.id
                            }"
                            @click="onSearchSetField(search_field, index)">
                              <i
                              :class="search_field.icon"></i>
                              <span v-html="search_field.text"></span>
                            </div>
                          </template>
                        </v-dropdown>
                      </div>
                      <div class="control">
                        <v-dropdown 
                        :opened.sync="search.mode_opened"
                        class="">
                          <template slot="display">
                            <div class="button">
                              <i :class="search_modes_index[search.data.mode].icon"></i>
                              <i class="caret-down"></i>
                            </div>
                          </template>
                          <template slot="content">
                            <div
                            v-for="search_mode in search_modes"
                            :key="search_mode.id"
                            class="item"
                            :class="{
                            'selected': search.data.mode === search_mode.id
                            }"
                            @click="onSearchSetMode(search_mode, index)">
                              <i
                              :class="search_mode.icon"></i>
                              <span v-html="search_mode.text"></span>
                            </div>
                          </template>
                        </v-dropdown>
                      </div>
                      <div class="control"
                      style="flex-grow: 0;"
                      v-if="search.data.field === 'cat'">
                        <v-select
                        class="full-width"
                        placeholder="Type"
                        :opened.sync="search.type_opened"
                        :floatingLabel="false"
                        v-model="search.data.group_type_id"

                        :items="group_attr"
                        @input="onGroupTypeSelect($event, index)"
                        >
                        </v-select>
                      </div>
                      <div class="control"
                      style="flex-grow: 0;"
                      v-if="search.data.field === 'organization'">
                        <v-select
                        class="full-width"
                        placeholder="Type"
                        :opened.sync="search.type_opened"
                        :floatingLabel="false"
                        v-model="search.data.org_type_id"
                        :items="organization_attr"
                        @input="onOrgTypeSelect($event, index)"
                        >
                        </v-select>
                      </div>
                      <div class="control"
                      style="flex-grow: 0;"
                      v-if="search.data.field === 'organization'">
                        <v-select
                        class="full-width"
                        placeholder="Rôle"
                        :opened.sync="search.role_opened"
                        :floatingLabel="false"
                        v-model="search.data.rel_type_id"
                        :items="get_attributes(search.data.org_type_id)"
                        @input="onOrgRoleSelect($event, index)"
                        >
                        </v-select>
                      </div>
                      <div class="control"
                      style="flex-grow: 1;">
                        <v-form-dropdown
                        v-if="(search.data.field === 'organization' ||
                        search.data.field === 'cat') &&
                        search.data.mode === '='"
                        :opened.sync="search.opened"
                        :hasReset="false"
                        placeholder="Organisation"
                        class="input-control no-overflow"
                        v-model="search.id"
                        :filter="search.data.value"
                        :display="search.data.value"
                        :items="search.items"
                        :min_letters="0"
                        @click.stop.prevent
                        @filter="onSearchFilter($event, index)"
                        @input="function (item_id, item) {
                          onSearchSelect(item_id, item, index)
                        }">
                        </v-form-dropdown>
                        <div v-else>
                          <input 
                          class="input no-style full-width" type="text" 
                          @input="onSearch($event.target.value, index)"
                          :value="search.data.value" placeholder="Recherche">
                        </div>
                        <a class="btn clear">
                          <i 
                          @click="onSearchDel(index)"
                          class="close2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="search_add_block" 
                style="padding-right: 0.5rem; clear: both;"
                class="column">
                    <div class="button pull-right"
                    @click="onAddSearch()">
                      <i class="search-plus"></i>
                    </div>
                    <div 
                    style="color: white;
                    display: inline-block;
                    line-height: 2.5rem;
                    float: right;
                    padding: 0 1rem;"
                    v-html="resTot + '&nbsp;résultat' + ((Number(resTot) > 1)?'s':'')">
                    </div>
                </div>
              </div>
            </div>

            <div class="column is-narrow"
            style="padding-right: 0.5rem;">
              <v-dropdown
              :opened.sync="col_dropdown_opened"
              id="col_dropdown"
              :right="true">
                <template slot="display">
                  <div class="button">
                    <i class="cols"></i>
                  </div>
                </template>
                <template slot="content">
                  <v-checkbox
                  v-for="(header, index) in headers"
                  :key="header.id"
                  class="item"
                  @input="onColChange(header, index, $event)"
                  :value="header.display"
                  :label="header.text" filled></v-checkbox>
                </template>
              </v-dropdown>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="row is-full-height">
      <div
      v-if="!pagination"
      class="rows is-full-height is-gapless">
        <div
        class="row is-narrow table-header"
        ref="tableHeader">
          <table>
            <thead>
              <tr v-no-select>
                <th class="col_tool left">
                  <v-checkbox
                  :value='false'
                  :disable='true'
                  filled
                  class="text-xs-center"></v-checkbox>
                </th>
                <th class="v-sortable"
                v-for="(header, index) in headers"
                v-if="header.display"
                :name="header.id"
                :key="header.id"
                :class="{
                  'col_id': header.id === 'id',
                  'v-sorted': header.sorted,
                  'v-sorted-descending': header.descending
                }"
                @click="onColSort(header)">
                    <span v-html="header.text"></span>
                    <i class="arrow_downward"></i>
                </th>
                <th class="col_tool left">
                </th>
                <th style="max-width: 16px"></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="row is-full-height"
        ref="table_scroll">
          <div class="table-body full-width loadable"
          :class="{
            loading: !loaded
          }"
          v-tableFix:tableHeader
          ref="tableBody">
            <v-list
            keyField="0"
            @scroll="onScroll"
            ref="vlist"
            :items="items">
              <template slot-scope="list">
                <tr
                :key="list.item.data[0]">
                  <td class="col_tool left"
                  name="">
                    <v-checkbox
                    class="no-transition"
                    :value="list.item.selected"
                    @input="onItemSelect2(list.item, $event)"></v-checkbox>
                  </td>
                  <td v-for="(cell, i) in list.item.data"
                  v-if="(i !== 0 || headers[0].display) && i!== 1"
                  :title="cell"
                  :name="headers[i].text"
                  v-html="cell"></td>
                  <!-- v-if="headers[i].display" -->
                  <td class="col_tool"
                  name="">
                    <div 
                    :class="{
                      active: list.item.data[1] === 1
                    }"
                    @click="onBookmarkClick(list.item, $event)"
                    class="bookmark-tag">
                      <i class="bookmark"></i>
                    </div>
                    <div
                    class="button"
                    style="margin-right: 5px;">
                      <i class="user-times"></i>
                    </div>
                    <router-link 
                    class="button"
                    :to="'/gestion/contact/edit/' + list.item.data[0]"
                    v-no-select
                    @click.prevent="onEdit(list.item.data[0])">
                      <i class="pencil"></i>
                    </router-link>

                  </td>
                </tr>
              </template>
            </v-list>
          </div>
        </div>
      </div>
      <v-table
      v-else
      ref="vTable"
      :headers="headers"
      :items="items"
      :all_selected="all_selected"
      @selectAll="onSelectAll"
      @select="onItemSelect"
      @colChange="onColChange"
      @colSort="onColSort"
      @edit="onEdit"
      class="loadable"
      :class="{
        loading: !loaded,
      }"
      >
        <template slot-scope="list">
          <tr
          :key="list.item.data[0]">
            <td class="col_tool left"
            name="">
              <v-checkbox
              :value="list.item.selected"
              @input="onItemSelect2(list.item, $event)"></v-checkbox>
            </td>
            <td v-for="(cell, i)  in list.item.data"
            :title="cell"
            v-if="(i !== 0 || headers[0].display) && i !== 1"
            :name="headers[i].text"
            v-html="cell"></td>
            <!-- v-if="headers[i].display" -->
            <td class="col_tool right"
            name="">
              <div 
              v-if="univers >1"
              :class="{
                active: list.item.data[1] === 1
              }"
              @click="onBookmarkClick(list.item, $event)"
              class="bookmark-tag">
                <i class="bookmark"></i>
              </div>
              <div
              class="button"
              style="margin-right: 5px;">
                <i class="user-times"></i>
              </div>
              <router-link 
              class="button"
              :to="'/gestion/contact/edit/' + list.item.data[0]"
              v-no-select
              @click.prevent="onEdit(list.item.data[0])">
                <i class="pencil"></i>
              </router-link>
            </td>
          </tr>
        </template>
      </v-table>
    </div>

    <div class="row is-narrow"
    v-if="pagination">
      <nav class="navbar primary justify-center">
        <v-pagination
        :pageCount="pageCount"
        :page="page"
        @change="onPageChange"
        ></v-pagination>
      </nav>
    </div>
    <div class="backdrop fullscreen"></div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import List_meta from './List_meta.js'
import { EventBus } from '../components/event-bus.js'

export default {
  data: () => ({
    univers: global.univers,
    search_fields: [],
    search_fields_index: {},
    search_modes: List_meta.search_modes,
    search_modes_index: List_meta.search_modes_index,
    col_key: {},
    // vlist: false,
    vlist: true,
    vlist_loading: false,
    current_sort: null,
    col_dropdown_opened: false,
    action_items: [
      {
        id: 'add',
        n: 'Ajouter'
      },
      {
        id: 'del',
        n: 'Supprimer'
      }
    ],
    action_type_items: [
      {
        id: '7',
        n: 'Groupe'
      },
      {
        id: '8',
        n: 'Organisation'
      }
    ],
    action_type_items_group_only: [
      {
        id: '7',
        n: 'Groupe'
      }
    ]
  }),
  directives: {
    tableFix: {
      componentUpdated: function (el, directive, vnode) {
        var vm = vnode.context
        vm.$nextTick(function () {
          vm.$nextTick(function () {
            var ref = directive.arg
            var target = vm.$refs[ref]
            vm.tableFix(el, target)
          })
        })
      }
    }
  },
  computed: {
    ...Vuex.mapGetters({
      resTot: 'listResTot',
      headers: 'listHeaders',
      data: 'listData',
      items: 'listItems',
      searchs: 'listSearchs',
      actions: 'listActions',
      all_selected: 'listAllSelected',
      pageCount: 'listPageCount',
      page: 'listPage',
      selected: 'listSelection',

      group_attr: 'listAttributesGroup',
      organization_attr: 'listAttributesOrganization',
      organization_roles: 'listRolesOrganization',
      get_attributes: 'listGetAttributes',
      pagination: 'listPagination',
      loaded: 'listLoaded',
      seeAll: 'listSeeAll',
      is_report: 'listIs_report',
    }),
    type_str: function () {
      return this.$route.params.type
    },
    modal_action_open: {
      get () {
        return this.$store.getters.listActionModalState
      },
      set (value) {
        this.$store.commit('ListSetActionModalState', value)
      }
    },
    action_mode: {
      get () {
        return this.$store.getters.listActionMode
      },
      set (value) {
        this.$store.commit('ListSetActionMode', value)
      }
    },
    modal_export_open: {
      get () {
        return this.$store.getters.listExportModalState
      },
      set (value) {
        this.$store.commit('ListSetExportModalState', value)
      }
    },
    export_mode: {
      get () {
        return this.$store.getters.listExportMode
      },
      set (value) {
        this.$store.commit('ListSetExportMode', value)
      }
    },
    modal_univers_open: {
      get () {
        return this.$store.getters.listUniversModalState
      },
      set (value) {
        this.$store.commit('ListSetUniversModalState', value)
      }
    },
    modal_univers_single_open: {
      get () {
        return this.$store.getters.listUniversSingleModalState
      },
      set (value) {
        this.$store.commit('ListSetUniversSingleModalState', value)
      }
    },
    modal_univers_single_action: {
      get () {
        return this.$store.getters.listUniversSingleAction
      },
      set (value) {
        this.$store.commit('ListSetUniversSingleAction', value)
      }
    },
    univers_mode: {
      get () {
        return this.$store.getters.listUniversMode
      },
      set (value) {
        this.$store.commit('ListSetUniversMode', value)
      }
    },
    univers_action: {
      get () {
        return this.$store.getters.listUniversAction
      },
      set (value) {
        this.$store.commit('ListSetUniversAction', value)
      }
    },
    modal_merge_open: {
      get () {
        return this.$store.getters.listMergeModalState
      },
      set (value) {
        this.$store.commit('ListSetMergeModalState', value)
      }
    },
    merge_main_id: {
      get () {
        return this.$store.getters.listMergeMainId
      },
      set (value) {
        this.$store.commit('ListSetMergeMainId', value)
      }
    },
    merge_items: {
      get () {
        return this.$store.getters.listMergeItems
      },
      set (items) {
        this.$store.commit('ListSetMergeItems', items)
      }
    },
  },
  methods: {
    ...Vuex.mapActions({
      getList: 'get_list',
      pushList: 'push_list',
      getData: 'get_data',
      setHeaders: 'ListSetHeaders',
      setHeaderDisplay: 'listSetHeaderDisplay',
      setHeaderSort: 'ListSetHeaderSort',
      addSearch: 'ListAddSearch',
      delSearch: 'ListDelSearch',
      setSearch: 'ListSetSearch',
      setSearchField: 'ListSetSearchField',
      setSearchMode: 'ListSetSearchMode',
      setSearchType: 'listSetSearchType',
      submitAction: 'listSubmitAction',
      submitExport: 'listSubmitExport',
      submitUnivers: 'listSubmitUnivers',
      submitSingleUnivers: 'listSubmitSingleUnivers',
      merge_contacts: 'merge_contacts'
    }),

    universModalSubmit: function (source, target) {
      this.submitSingleUnivers()
      .then((response) => {
        this.$store.commit('ListSetUniversSingleModalState', false)
        this.$store.dispatch('get_list')
      }, (response) => {
        // error callback
      })
    },

    tableFix: function (source, target) {
      this.$nextTick(function () {
        var headersSource = source.querySelectorAll('tr:first-child td')
        var headersTarget = target.querySelectorAll('th')
        var width
        var i
        var len = headersSource.length

        for (i = 0; i < len; i++) {
          width = parseInt(headersSource[i].offsetWidth)
          headersTarget[i].style.width = width + 'px'
        }
      })
    },

    onBookmarkClick: function (item, e) {
      var action = ''

      this.modal_univers_single_action = null

      if (item.data[1] === 1) {
        action = 'del'
      }
      else if (item.data[1] === 0) {
        action = 'add'
      }

      var data = {
        action: action,
        id: item.data[0]
      }
      // console.log(data)

      this.modal_univers_single_action = data
      this.modal_univers_single_open = true
    },

    // submitUniversSingle: function () {
      // console.log(item, e)
    // },

    onScroll: function (scrollTop) {
      if (!this.vlist_loading &&
        scrollTop / this.$refs.vlist.scrollMax > 0.7 &&
        this.page < this.pageCount) {
        let vm = this
        this.vlist_loading = true
        this.$store.commit('ListSetPage', this.page + 1)
        this.pushList()
        .then(function () {
          vm.vlist_loading = false
        })
      }
    },

    onSelectAll: function (selected) {
      this.$store.commit('ListSetAllItemSelect', {
        selected: selected
      })
    },

    onItemSelect: function (param) {
      this.$store.commit('ListSetItemSelect', {
        item: param.item,
        selected: param.selected
      })
    },
    onItemSelect2: function (item, selected) {
      // console.log('onItemSelect2', item, selected)
      this.$store.commit('ListSetItemSelect', {
        item: item,
        selected: selected
      })
    },

    onColChange: function (header, index, display) {
      this.$store.commit('ListSetHeaderDisplay', {
        header: header,
        index: index,
        display: display
      })
      this.$nextTick(function () {
        this.getList(false)
      })
    },

    onColSort: function (header) {
      this.setHeaderSort(header)
      this.$nextTick(function () {
        this.getList(true)
      })
    },

    onAddSearch: function () {
      this.addSearch(List_meta.get_default_search())
    },

    onSearchDel: function (index) {
      let search = this.searchs[index]
      if (search.data.value === '' && this.searchs.length > 1) {
        this.delSearch(index)
      }
      else {
        let search_state = List_meta.get_default_search()
        this.setSearch({
          index: index,
          search_state: search_state
        })
      }
    },

    onSearchSetField: function (searchField, index) {
      if (searchField.id === 'organization' ||
      searchField.id === 'cat') {
        this.setSearchMode({
          index: index,
          mode: List_meta.search_modes[3]
        })
      }

      this.setSearchField({
        index: index,
        field: searchField
      })

      this.$store.commit('ListSetOpened', {
        index: index,
        field: null
      })
    },

    onSearchSetMode: function (searchMode, index) {
      // console.log('searchMode', searchMode)
      // global.dropdown.closeAll()
      this.setSearchMode({
        index: index,
        mode: searchMode
      })
      
      this.$store.commit('ListSetOpened', {
        index: index,
        field: null
      })
    },

    onSearchFilter: function (value, index) {
      // console.log('onSearchFilter', {
      //   index: index,
      //   value: value
      // })
      this.$store.commit('ListSetSearchFilter', {
        index: index,
        value: value
      })
    },

    onSearchSelect: function (item_id, item, index) {
      // console.log('onSearchSelect', item)
      this.$store.commit('ListSetSearchId', {
        index: index,
        id: item.id
      })
      this.$store.commit('ListSetSearchValue', {
        index: index,
        value: item.n
      })
      this.getList(true)
    },

    onSearch: function (value, index) {

      // console.log('onSearch', value, index)
      this.$store.commit('ListSetSearchValue', {
        index: index,
        value: value
      })
      this.getList(true)
      // console.log('loaded', this.loaded)
    },

    onPageChange: function (page) {
      this.$store.commit('ListSetPage', page)
      this.getList(true)
    },

    onEdit: function (contact_id) {
      let vm = this
      vm.$router.push('/gestion/' + this.$route.params.type + '/edit/' + contact_id)
    },

    onActionSelect: function (action, index) {
      this.$store.commit('ListSetActionLabel', {
        index: index,
        action: action
      })
    },
    onActionObjectSelect: function (data_type_id, index) {
      // console.log('onActionObjectSelect', data_type_id)
      this.$store.commit('ListSetActionObject', {
        index: index,
        data_type_id: data_type_id
      })
    },
    onActionTypeSelect: function (type_id, index) {
      this.$store.commit('ListSetActionType', {
        index: index,
        type_id: type_id
      })
    },
    onActionFilter: function (value, index) {
      this.$store.commit('ListSetActionFilter', {
        index: index,
        value: value
      })
    },
    onActionDataSelect: function (item_id, item, index) {
      this.$store.commit('ListSetActionValue', {
        index: index,
        data_id: item_id,
        type_id: item.type,
        display: item.n
      })
    },
    onActionAdd: function () {
      let action_state = List_meta.get_default_action()
      this.$store.commit('ListAddAction', action_state)
    },
    onActionDel: function (index) {
      this.$store.commit('ListDelAction', index)
    },

    onGroupTypeSelect: function (value, index) {
      // console.log(value, index)

      this.$store.commit('ListSetSearchGroupType', {
        index: index,
        value: value
      })
      this.getList(true)
    },
    onOrgTypeSelect: function (value, index) {
      // console.log(value, index)

      this.$store.commit('ListSetSearchOrgType', {
        index: index,
        value: value
      })
      this.getList(true)
    },
    onOrgRoleSelect: function (value, index) {
      // console.log(value, index)

      // this.$store.commit('ListSetSearchOrgRole', {
      //   index: index,
      //   value: value
      // })
      this.getList(true)
    }
  },

  mounted () {
    let vm = this

    let searchTypeId = {
      '/gestion/contact': 1,
      '/gestion/organisation': 2,
      '/gestion/contact_externe': 3,
      '/gestion/organisation_externe': 4,
    }

    // console.log('this.$route.path', this.$route.path)
    // let type_id = ((this.$route.path.indexOf('/contact') < 0) ? 2 : 1)
    
    let type_id = 1

    if(searchTypeId[this.$route.path]){
      type_id = searchTypeId[this.$route.path]
    }

    // let type_id = ((this.$route.path.indexOf('/contact') < 0) ? 2 : 1)

    this.setSearchType(type_id)

    if (type_id === 1 || type_id === 3 ) {
      this.search_fields_index = List_meta.search_fields_index
      this.search_fields = List_meta.search_fields
    }
    else {
      this.search_fields_index = List_meta.search_fields_org_index
      this.search_fields = List_meta.search_fields_org
    }

    if (this.searchs.length === 0) {
      let search_state = List_meta.get_default_search()
      this.addSearch(search_state)
    }

    if (this.actions.length === 0) {
      let action_state = List_meta.get_default_action()
      this.$store.commit('ListAddAction', action_state)
    }

    if (this.headers.length === 0) {
      if (type_id === 1) {
        this.setHeaders(List_meta.headers)
      }
      else {
        this.setHeaders(List_meta.headers_org)
      }
    }

    EventBus.$on('window_resize', function () {
      if (vm.vlist && vm.$refs.vlist) {
        vm.$refs.vlist.resize()
      }
    })

    EventBus.$on('list_set', function (scrollTop) {
      if (vm.vlist && vm.$refs.vlist) {
        vm.$store.commit('ListSetPage', 1)
        vm.vlist_loading = false
        if (scrollTop) {
          vm.$refs.vlist.ScrollToTop()
        }
      }
      else if (vm.$refs.vTable) {
        if (scrollTop) {
          vm.$refs.vTable.scrollToTop()
        }
      }
    })

    this.getList(true)
    // this.modal_open = true
  }
}
</script>

<style>
.tabs .tab__item--active {
    border-bottom: 4px solid #448aff;
}

.v-sortable {
  cursor: pointer;
  position: relative;
}

/*.v-sortable span,*/
.v-sortable i {
  transition: all .4s cubic-bezier(.25,.8,.25,1);
}

.v-sortable i {
  opacity: 0;
}

.v-sortable:hover i {
  opacity: 0.5;
}

.v-sortable.v-sorted i {
  opacity: 1;
}
/*
.v-sortable span {
  transform: translateX(-20px);
  display: inline-block;
}

.v-sortable:hover span,
.v-sortable.v-sorted span {
  transform: translateX(0px);
}*/

/* --> il me semble que ça fait laguer la transition slider sur FF */

.v-sortable.v-sorted-descending i {
  /*transform: translateY(-50%) rotate(180deg);*/
  transform: rotate(180deg);
}

.modal .item-icon .button {
  //font-size: 1.5rem;
  line-height: 2rem;
  display: inline-block;
}

.modal .item-icon i {
  font-size: 1.4rem;
  padding: 0px;
  line-height: 1.7rem;
  display: inline-block;
  text-align: center;
  margin: auto;
}

.table-header > table {
  border-bottom: 1px solid #ddd;
  background-color: #f9f7f7;
}

.table-body tr{
  border-bottom: 1px solid #ddd;
}

.table-header table,
.table-body table {
  width: 100% !important;
  table-layout: fixed !important;
}

.loadable {
  position: relative;
  transition: all 1s ease;
}

.loadable:before {
  /*background-color: rgba(200, 103, 103, 0.8);*/
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  pointer-events: none;
}

.loadable.loading:before {
  background-color: rgba(91, 95, 141, 0.2);
}
/*
.search-nav input[placeholder],
.search-nav [placeholder],
.search-nav *[placeholder] {
  color: #333 !important;
}*/
.bookmark-tag {
  float: left;
  display: inline-block;
  color: #ccc;
  cursor: pointer;
}

.bookmark-tag.active {
  color: #363636;
}

.bookmark-tag i {
  line-height: 36px;
  font-size: 18px;
}

.col_tool {
  width: 70px;
  text-align: center;
}

table th.col_tool:last-child,
table td.col_tool:last-child {
  width: 125px;
}


table th.col_tool,
table td.col_tool {
  overflow: visible;
}

.col_tool.right {
  text-align: right;
}

.col_tool.left {
  text-align: left;
}

.col_tool .v-checkbox-input {
  padding-left: 10px;
}

.col_id {
  width: 60px;
}

label[disabled] {
  color: #aaa;
  pointer-events: none;
  cursor: not-allowed !important;
}

.backdrop {
  background: rgba(0, 0, 0, .4);
  z-index: 110;
  display: none;
}

.radio-item-list {
  display: block;
  padding: 0.5rem 0;
  line-height: 1em;
}
</style>
